import placeholderUrl from '@assets/images/placeholder.png';
import { HawkSearchComponents, HawkSearchGlobal, SearchResultsItem, SearchResultsItemComponentConfig, SearchResultsItemComponentModel } from '@models';
import { trackingService } from '@services';
import { BaseComponent } from '../../base.component';
import defaultHtml from './search-results-item.component.hbs';

declare let HawkSearch: HawkSearchGlobal;

export class SearchResultsItemComponent extends BaseComponent<SearchResultsItemComponentConfig, SearchResultsItem, SearchResultsItemComponentModel> {
    protected override componentName: keyof HawkSearchComponents = 'search-results-item';
    protected override defaultHtml = defaultHtml;
    protected override bindFromEvent = false;

    protected override renderContent(): boolean {
        return !!this.data;
    }

    protected override getContentModel(): SearchResultsItemComponentModel {
        return {
            ...this.data!,
            strings: {
                sale: this.configuration?.strings?.sale ?? 'Sale'
            }
        };
    }

    protected bindChildElements(): void {
        this.rootElement.querySelectorAll('[hawksearch-image]').forEach((e) => {
            e.addEventListener('error', (event: Event): void => {
                const element = event.currentTarget as HTMLImageElement;

                element.src = HawkSearch.config.placeholderImageUrl || placeholderUrl;
            });
        });

        this.rootElement.querySelectorAll('[hawksearch-link]').forEach((e) => {
            e.addEventListener('click', ((event: PointerEvent): void => {
                if (!this.data) {
                    return;
                }

                trackingService.trackSearchResultClick(this.data.id, this.data.url, event);
            }) as EventListener);
        });
    }
}
